<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          <label for="filtro-motivo">Filtro por Motivo</label>
          <v-select
            id="filtro-motivo"
            v-model="motivoEventos.selected"
            class="mb-1"
            multiple
            label="nome"
            :options="motivoEventos.options"
            @input="filtrarPorMotivo"
          />
        </b-col>
        <b-col
          md="2"
          sm="2"
        >
          <label for="filtro-motivo">Por página</label>
          <v-select
            id="filtro-motivo"
            v-model="eventsPerPage.selected"
            class="mb-1"
            :options="eventsPerPage.options"
            :clearable="false"
            @change="filtroEvento()"
          />
        </b-col>
        <b-col>
          <b-form-checkbox
            v-model="checked"
            :disabled="checkedAll"
          >
            <span class="vs-checkbox">
              <span
                class="vs-checkbox--check"
              />
            </span>
            <span class="vs-label">{{ 'Mostrar Eventos Ocultos' }}</span>
          </b-form-checkbox>
          <b-form-checkbox
            v-model="checkedAll"
            :disabled="checked"
          >
            <span class="vs-checkbox">
              <span
                class="vs-checkbox--check"
              />
            </span>
            <span class="vs-label">{{ 'Mostrar Todos' }}</span>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-table
            sticky-header="70vh"
            :items="checked ? ficticyOcult : checkedAll ? ficticyAll : ficticy"
            :fields="fields"
            :per-page="eventsPerPage.selected"
            :current-page="eventsPerPage.currentPage"
            :tbody-tr-class="rowClass"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            striped
            responsive
          >
            <template #cell(show_details)="row">
              <div
                v-show="row.item.fixo"
                class="mb-1"
              >
                <feather-icon
                  icon="FlagIcon"
                  size="18"
                />
              </div>
              <div
                v-show="row.item.oculto && checkedAll"
                class="mb-1"
              >
                <feather-icon
                  icon="EyeOffIcon"
                  size="18"
                />
              </div>
              <b-form-checkbox
                v-model="selectedRow"
                :value="row.item"
                class="custom-control-primary"
                @change="row.toggleDetails"
              >
                <span class="vs-checkbox">
                  <span class="vs-checkbox--check">
                    <i class="vs-icon feather icon-check" />
                  </span>
                </span>
                <span class="vs-label">{{ row.detailsShowing ? 'Esconder' : 'Descrição' }}</span>
              </b-form-checkbox>
            </template>

            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col
                    md="7"
                    class="mb-1"
                  >
                    <div v-html="row.item.historico" />
                    <br>
                    <span v-show="row.item.comments !== null"><strong>OBSERVAÇÃO:</strong> <b-badge
                      class="text-wrap text-left"
                      variant="light-secondary"
                    >{{ row.item.comments }} </b-badge></span>
                  </b-col>
                </b-row>

                <div class="demo-inline-spacing">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                  >
                    Esconder Descrição
                  </b-button>

                  <b-button
                    v-show="row.item.comments === null && row.item.storeObservacao && verificaDataEvento(row.item.datahora)"
                    size="sm"
                    variant="outline-primary"
                    @click="openAddCommentsModal(row.item)"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="color-icon"
                    />
                    observação
                  </b-button>
                  <b-button
                    v-if="!row.item.fixo && isExecutive === 'Supervisor(a) Cobrança'"
                    size="sm"
                    variant="outline-info"
                    @click="fixarEvento(row.item.id_row, row.item.fixo)"
                  >
                    Fixar evento
                  </b-button>
                  <b-button
                    v-show="isExecutive === 'Supervisor(a) Cobrança'"
                    v-else
                    size="sm"
                    variant="outline-info"
                    @click="fixarEvento(row.item.id_row, row.item.fixo)"
                  >
                    Desafixar evento
                  </b-button>
                  <b-button
                    v-if="!row.item.oculto && isExecutive === 'Supervisor(a) Cobrança'"
                    v-show="isExecutive === 'Supervisor(a) Cobrança'"
                    size="sm"
                    variant="outline-warning"
                    @click="ocultarEvento(row.item.id_row, row.item.oculto)"
                  >
                    Ocultar evento
                  </b-button>
                  <b-button
                    v-show="isExecutive === 'Supervisor(a) Cobrança'"
                    v-else
                    size="sm"
                    variant="outline-warning"
                    @click="ocultarEvento(row.item.id_row, row.item.oculto)"
                  >
                    Desocultar evento
                  </b-button>

                </div>

              </b-card>
            </template>

            <template #cell(nome)="data">
              <b-avatar
                :text="getInitials(data.item.nome)"
                size="32"
              />
              {{ fisrtLastName(data.item.nome) }}
            </template>
          </b-table>
          <b-pagination
            v-model="eventsPerPage.currentPage"
            :total-rows="checked ? totalRowsOcult : checkedAll ? ficticyAllRows : totalRows"
            :per-page="eventsPerPage.selected"
            align="center"
            size="md"
            class="my-0"
          />

          <b-modal
            ref="addComments"
            cell="row"
            title="Adicionar observações"
            ok-only
            no-close-on-backdrop
            @ok="sendCommentsToBack"
          >
            <label for="textarea-default">Observação</label>
            <b-form-textarea
              id="textarea-default"
              v-model="commentsToEvents.observacao"
              placeholder="Textarea"
              rows="3"
            />
          </b-modal>
        </b-col></b-row>
    </b-card>
  </div>
</template>

<script>

// Importando dependencia do bootstrap
import {
  BBadge,
  BFormTextarea,
  BRow,
  BCol,
  BTable,
  BPagination,
  BAvatar,
  BFormCheckbox,
  BCard,
  BButton,
} from 'bootstrap-vue'

// Importando dependencias do Vue
import vSelect from 'vue-select'

import { mapState } from 'vuex'
// Importando mecanismo de fazer requisições
import axios from '@/../axios-auth'

export default {
  components: {
    BBadge,
    BFormTextarea,
    BRow,
    BCol,
    BTable,
    BPagination,
    BAvatar,
    BFormCheckbox,
    BCard,
    BButton,
    vSelect,
  },
  props: {
    updateTabs: {
      type: Function,
      required: true,
    },

  },
  data() {
    return {
      comments: [],
      selectedRow: [],
      checked: false,
      checkedAll: false,
      commentsToEvents: {
        observacao: '',
        evento_id: '',
      },

      newEvento: false,
      clienteId: this.$route.params.id,
      isExecutive: localStorage.getItem('funcao'),
      sortBy: 'fixo',
      sortDesc: true,
      fields: [
        { key: 'show_details', label: 'Mostrar Detalhes' },
        { key: 'datahoraFormatada', label: 'Data e Hora' }, // Usar datahoraFormatada
        { key: 'nome', label: 'usuário' },
        { key: 'evento', label: 'Evento' },
      ],
      // Motivo dos eventos
      motivoEventos: {
        options: [],
        selected: null,
      },
      // Quantidade de eventos por pagina
      eventsPerPage: {
        options: [100, 200, 300],
        selected: 100,
        currentPage: 1,
      },

      // Eventos manipuláveis
      items: [],
      ficticy: [],
      totalRows: 0,
      itemsOcult: [],
      ficticyOcult: [],
      totalRowsOcult: 0,
      ficticyAll: [],
      ficticyAllRows: 0,
    }
  },
  computed: {
    ...mapState({
      updatedItems: state => {
        const { eventos } = state.eventos
        return eventos
      },
    }),
  },
  watch: {
    updatedItems(n) {
      this.setItems(n)
    },
  },
  created() {
    this.setItems(this.$store.getters['eventos/listEvents'])
    this.getMotivoEventos()
  },
  methods: {
    rowClass(item, type) {
      const colorClass = 'table-danger'
      if (!item || type !== 'row') { return }

      // eslint-disable-next-line consistent-return
      if (item.evento === '11 - ATENÇÃO' || item.evento === '18 - COMUNICAÇÃO INTERNA') { return colorClass }
    },
    setItems(items) {
      const eventos = []
      const eventosOcultados = []
      const eventosAll = []
      items.forEach(item => {
        item.descricao = item.descricao.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '\n')
        const idsAllow = [5, 9, 20, 1]
        if (idsAllow.includes(item.motivo_evento.id)) {
          if (item.parametros_contato) {
            const {
              call_id: callId,
              cpf,
              origem,
              telefone,
            } = item.parametros_contato
            const conc = `
            <br>
            <p> ========== PARAMÊTROS CONTATO ===========
              - ID DA CHAMADA: ${callId}
              - CPF: ${cpf}
              - ORIGEM: ${origem}
              - Telefone: ${telefone}
            </p>`
            item.descricao += conc
          }
        }

        const eventoBase = {
          id: item.usuario_empresas.id,
          datahora: this.dataHora(item.created_at, false), // Objeto Date!
          datahoraFormatada: this.dataHora(item.created_at), // String formatada
          id_row: item.id,
          comments: item.observacao,
          nome: item.usuario_empresas.nome,
          evento: `${item.motivo_evento.id} - ${item.motivo_evento.nome}`,
          historico: item.descricao,
          fixo: item.fixo === false ? null : item.fixo,
          motivo_evento_id: item.motivo_evento.id,
          storeObservacao: item.motivo_evento.observacao,
          tipo: item.motivo_evento.tipo,
          categoria: item.motivo_evento.categoria,
          canal: item.canal,
          origem: item.origem,
          numero: item.numero,
        }

        if (item.oculto !== true) {
          eventos.push(eventoBase)
        } else {
          eventosOcultados.push({ ...eventoBase, oculto: item.oculto })
        }
        eventosAll.push({ ...eventoBase, oculto: item.oculto }) // Todos os eventos, ocultos ou não
      })

      this.items = this.ordenarEventos(eventos)
      this.ficticy = [...this.items]
      this.totalRows = this.items.length

      this.itemsOcult = this.ordenarEventos(eventosOcultados)
      this.ficticyOcult = [...this.itemsOcult]
      this.totalRowsOcult = this.itemsOcult.length

      this.ficticyAll = this.ordenarEventos(eventosAll)
      this.ficticyAllRows = this.ficticyAll.length
    },
    ordenarEventos(eventos) {
      return eventos.sort((a, b) => {
        if (a.fixo && !b.fixo) return -1
        if (!a.fixo && b.fixo) return 1
        // Ordena da mais recente para a mais antiga:
        return b.datahora.getTime() - a.datahora.getTime()
      })
    },

    async getMotivoEventos() {
      try { // Use try-catch para lidar com erros na requisição
        const response = await axios.get('api/v1/motivo_evento', {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          },
        })

        const { dados } = response.data
        const motivos = dados.map(item => ({
          cor: item.cor,
          created_at: item.created_at,
          grupo: item.grupo,
          id: item.id,
          nome: `${item.id} - ${item.nome}`,
          status: item.status,
        }))

        this.motivoEventos.options = motivos.sort((a, b) => a.id - b.id)
      } catch (error) {
        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          },
          content: `Erro ao obter motivos de eventos: ${error.message}`,
        })
      }
    },

    filtrarPorMotivo() {
      if (this.motivoEventos.selected && this.motivoEventos.selected.length > 0) {
        const list = []
        this.motivoEventos.selected.forEach(motivoSelecionado => {
          this.items.forEach(item => {
            if (item.evento === motivoSelecionado.nome) {
              list.push(item)
            }
          })
        })
        this.ficticy = this.ordenarEventos(list)
        this.totalRows = list.length
      } else {
        this.ficticy = this.ordenarEventos([...this.items])
        this.totalRows = this.items.length
      }
    },
    updateEvents() {
      const { clienteId, setItems } = this
      axios
        .get(`api/v1/clientes/event/${clienteId}`, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer '.concat(localStorage.getItem('token')),
          },
        })
        .then(async res => {
          const { eventos } = res.data
          if (eventos) {
            setItems(eventos)
          }
        })
    },
    inserirNovoEvento(evento, motivo) {
      const dadosEvento = {
        id: 1001,
        evento: `${evento.motivo_evento_id} - ${motivo}`,
        historico: evento.descricao,
        nome: 'Nome Executivo',
        datahora: this.dataHoraAtual(),
      }
      this.items.unshift(dadosEvento)
    },
    dataHoraAtual() {
      const data = new Date()
      const dia = String(data.getDate()).padStart(2, '0')
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const ano = data.getFullYear()
      const hora = String(data.getHours()).padStart(2, '0')
      const min = String(data.getMinutes()).padStart(2, '0')
      return `${dia}/${mes}/${ano} ${hora}:${min}`
    },
    dataHora(dataISO, formatar = true) {
      const data = new Date(dataISO)

      if (!formatar) {
        return data // Retorna o objeto Date
      }

      const dia = String(data.getDate()).padStart(2, '0')
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const ano = data.getFullYear()
      const hora = String(data.getHours()).padStart(2, '0')
      const min = String(data.getMinutes()).padStart(2, '0')
      return `${dia}/${mes}/${ano} ${hora}:${min}`
    },

    async sendCommentsToBack() {
      axios
        .post('api/v1/eventos/add/observacao', this.commentsToEvents, {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            accept: 'application/json',
          },
        })
        .then(() => {
          this.clearModalCommentsToBack()
          this.updateTabs()
          this.$swal({
            title: 'Observação adicionada!',
            icon: 'success',
            text: 'Novo cadastro adicionado!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(() => {
          this.clearModalCommentsToBack()
          this.updateTabs()
          this.$swal({
            title: 'ERRO!',
            icon: 'error',
            text: 'Ocorreu um erro durante o cadastro!',
            customClass: {
              confimButton: 'btn btn-danger',
            },
          })
        })
    },
    verificaDataEvento(dataEvento) {
      // Verifica se dataEvento é um objeto Date válido
      // eslint-disable-next-line no-restricted-globals
      if (!(dataEvento instanceof Date) || isNaN(dataEvento)) {
        this.$toast({
          component: 'b-toast',
          props: {
            title: 'Erro',
            variant: 'danger',
            solid: true,
          },
          content: `dataEvento não é um objeto Date válido: ${dataEvento}`,
        })
        return false // Ou algum outro valor padrão, dependendo do seu caso
      }

      const twentyFourHoursAgo = Date.now() - (24 * 60 * 60 * 1000)
      return dataEvento.getTime() >= twentyFourHoursAgo
    },
    async fixarEvento(idRow, status) {
      const statusFixado = status
      let body

      if (statusFixado) {
        body = {
          fixar: false,
          evento_id: idRow,
        }
      } else {
        body = {
          fixar: true,
          evento_id: idRow,
        }
      }

      axios
        .post('api/v1/eventos/fixar', body, {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            accept: 'application/json',
          },
        })
        .then(() => {
          this.$swal({
            title: 'Evento alterado!',
            icon: 'success',
            text: 'Evento alterado com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(() => {
          this.$swal({
            title: 'ERRO!',
            icon: 'error',
            text: 'Ocorreu um erro ao alterar o evento!',
            customClass: {
              confimButton: 'btn btn-danger',
            },
          })
        })
      await this.updateTabs()
    },

    async ocultarEvento(idRow, status) {
      const statusOculto = status
      let body

      if (statusOculto) {
        body = {
          oculto: false,
          evento_id: idRow,
        }
      } else {
        body = {
          oculto: true,
          evento_id: idRow,
        }
      }
      axios
        .post('api/v1/eventos/ocultar', body, {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
            accept: 'application/json',
          },
        })
        .then(() => {
          this.$swal({
            title: 'Evento Alterado!',
            icon: 'success',
            text: 'Evento alterado com sucesso!',
            timer: 1500,
            showConfirmButton: false,
          })
        })
        .catch(() => {
          this.$swal({
            title: 'ERRO!',
            icon: 'error',
            text: 'Ocorreu um erro ao alterar o evento!',
            customClass: {
              confimButton: 'btn btn-danger',
            },
          })
        })
      await this.updateTabs()
    },
    clearModalCommentsToBack() {
      this.commentsToEvents.observacao = ''
      this.commentsToEvents.evento_id = ''
    },
    openAddCommentsModal(item) {
      this.commentsToEvents.evento_id = item.id_row
      this.$refs.addComments.show()
    },
  },
}
</script>
